import { ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Layout wrapper that handles mobile spacing for a `SidebarShell` + main
 * content pair. Expects exactly two children: the sidebar, then the main
 * content.
 */
export const SidebarPageLayout = ({ children, className }: Props) => {
  const childrenArray = Array.isArray(children) ? children : [children];
  const [sidebar, mainContent] = childrenArray;

  return (
    <div className={cn("flex h-dvh bg-white pt-8 lg:pt-0", className)}>
      {sidebar}
      <main className="flex-1 overflow-auto">{mainContent}</main>
    </div>
  );
};
